import { Examen } from './../../../../interfaces/examen';
import { Component, OnInit, ViewChild, AfterContentChecked } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProspectoService } from '../../../../providers/prospecto.service';
import { MatSnackBar, MatTabChangeEvent, MatTabGroup } from '@angular/material';
import { Incidencia } from '../../../../interfaces/incidencia';
import { Entidad, TipoEntidad } from '../../../../interfaces/entidad';
import { ContactoService } from '../../../../providers/contacto.service';
import { ListarContactosComponent } from '../../../../forms/entidad/contactos/listar-contactos/listar-contactos.component';
import { Contacto, TipoContacto } from '../../../../interfaces/contacto';
import { VerCotizacionesComponent } from '../../../../forms/cotizaciones/ver-cotizaciones/ver-cotizaciones.component';
import { DetalleService, DetalleNombre } from '../../../../providers/detalle.service';
import { Direccion } from '../../../../interfaces/direccion';
import { ListarEntidadResponsablesComponent } from '../../../../forms/entidad/entidad-responsables/listar-entidad-responsables/listar-entidad-responsables.component';
import { Telefono } from '../../../../components/telefono/telefono.component';
import { TipoCliente } from '../../../../forms/clientes/tipos-cliente/tipo-cliente/tipo-cliente';
import { VerIncidenciasComponent } from '../../../../forms/incidencias/ver-incidencias/ver-incidencias.component';
@Component({
  selector: 'app-detalle-prospecto-pagina',
  templateUrl: './detalle-prospecto-pagina.component.html',
  styleUrls: ['./detalle-prospecto-pagina.component.scss']
})
export class DetalleProspectoPaginaComponent implements OnInit, AfterContentChecked {
  cargando: boolean = true;
  IdProspecto?: number | string;
  prospecto: Entidad;
  incidencias: Incidencia[] = []; // incidencias del prospecto
  tabSelectedIndex: number = 0;
  max_progreso: number;
  progreso: any;

  @ViewChild('verIncidencias') verIncidencias: VerIncidenciasComponent;
  @ViewChild('verCotizaciones') verCotizaciones: VerCotizacionesComponent;
  @ViewChild(ListarContactosComponent) listadoContactos: ListarContactosComponent;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild('listadoEntidadResponsables') listadoEntidadResponsables: ListarEntidadResponsablesComponent;
  

  constructor(
    private route: ActivatedRoute,
    private prospectoService: ProspectoService,
    private snackBar: MatSnackBar,
    private contactoService: ContactoService,
    private detalleService: DetalleService
  ) { }

  ngOnInit() {
    this.prospecto = new Entidad();

    // crear un prospecto con el ID buscado
    this.route.params.subscribe(params => {
      this.prospecto.IdEntidad = params['id'];
      this.IdProspecto = params['id'];
      this.actualizarDetalle();
    });
  }

  ngAfterContentChecked() {
    if (this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.length > 1) {
      this.tabSelectedIndex = this.detalleService.getDetalleTabActivo(DetalleNombre.DETALLE_PROSPECTO);
    }
  }



  // get active tab on change
  selectedTabChange(event: MatTabChangeEvent): void {
    var tabActivo = +event.index;
    this.detalleService.setDetalleTabActivo(DetalleNombre.DETALLE_PROSPECTO, tabActivo);
  }

  actualizarIncidencias(): void { // actualizar incidencias del prospecto
     this.verIncidencias.actualizarTabla();
  }

  actualizarCotizaciones(): void { // actualizar cotizaciones del prospecto
    this.verCotizaciones.actualizarTabla();
  }

  actualizarResponsables(): void { // actualizar archivos
    if (this.listadoEntidadResponsables) {
      this.listadoEntidadResponsables.IdEntidad = this.IdProspecto;
      this.listadoEntidadResponsables.actualizarTabla();
    }
  }

  actualizarDetalle(): void { // traer datos del prospecto para mostrarlos
    this.cargando = true;
    this.prospectoService.getProspectos(
      {
        page: 0,
        pageSize: 10
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        IdEntidad: this.IdProspecto,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var entidad = respuesta.data.entidades[0];
         console.log('entidadad', entidad);
          // console.log('entidadad origen', entidad.origen);
          this.max_progreso = respuesta.data.max_progreso;
          this.progreso = entidad.progreso;
          if (entidad) {
            this.prospecto = new Entidad(
              entidad.id,
              entidad.razonSocial,
              entidad.nombreFantasia,
              entidad.nombre,
              entidad.apellido,
              entidad.cargo,
              entidad.dia_nacimiento,
              entidad.mes_nacimiento,
              entidad.telefonoPrincipal,
              entidad.telefonoPrincipalCodigoPais,
              entidad.telefonoPrincipalCodigoArea,
              entidad.telefonoPrincipalNumero,
              entidad.telefonoMovil,
              entidad.telefonoMovilCodigoArea,
              entidad.telefonoMovilCodigoPais,
              entidad.telefonoMovilNumero,
              entidad.cuit,
              entidad.fechaContacto,
              <Direccion>{
                codigoPostal: entidad.codPostal,
                calle: entidad.direccionCalle,
                departamento: entidad.direccionDepartamento,
                numero: entidad.direccionNumero,
                piso: entidad.direccionPiso,
                localidad: entidad.localidad,
                pais: {
                  IdPais: entidad.pais.IdPais,
                  descripcion: entidad.pais.descripcion
                },
                provincia: entidad.provincia
              },
              entidad.fechaModificacion,
              !!+entidad.VIP,
              <TipoEntidad>{
                IdTipo: entidad.tipo.IdTipo,
                descripcion: entidad.tipo.TipoDescripcion
              },
              entidad.idExtranet,
              null,
              entidad.created_by,
              <TipoCliente>{
                id: entidad.tipoCliente.id,
                descripcion: entidad.tipoCliente.descripcion
              },
              null,
              entidad.referencia,
              entidad.esCliente,
              entidad.observacion,
              entidad.redSocial1,
              entidad.redSocial2,
              entidad.paginaWeb,
              entidad.direccionFacturacion,
              entidad.IdTango,
              entidad.condicionVenta,
              entidad.porcentajeBonificacion,
              entidad.transporte,
              entidad.certificacion,
              entidad.fechaCertificacion,
              entidad.pago,
              entidad.examen,
              entidad.kit,
              entidad.perfil,
              entidad.email,
              entidad.origen
            );

            this.traerContactos(+this.prospecto.IdEntidad); // traer sus contactos
            this.actualizarResponsables();
          } else {
            this.snackBar.open('No se encontraron los datos buscados', 'OK', { duration: 2750 });
          }
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }
  colorProgreso(perc, min, max) {
    var base = (max - min);

    if (base == 0) {
      perc = 100;
    } else {
      perc = (perc - min) / base * 100;
    }
    var r, g, b = 0;

    if (perc < 50) {
      r = 255;
      g = Math.round(5.1 * perc);
    } else {
      g = 255;
      r = Math.round(510 - 5.10 * perc);
    }
    var h = r * 0x10000 + g * 0x100 + b * 0x1;
    return '#' + ('000000' + h.toString(16)).slice(-6);
  }

  colorFuente(perc, min, max) {
    var base = (max - min);
    if (base == 0) {
      perc = 100;
    } else {
      perc = (perc - min) / base * 100;
    }
    if (perc < 50) {
      return '#' + 'ffffff';
    } else {
      return '#' + '000000';
    }
  }

  traerContactos(IdEntidad: number): void {
    if (IdEntidad) { // si hay un ID
      this.prospecto.contactos = [];
      this.listadoContactos.setCargando(true);
      this.contactoService.getContactos(
        {
          page: null,
          pageSize: 50
        },
        {
          sort: 'nombre',
          order: 'asc'
        },
        {
          IdEntidad: IdEntidad
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.contactos) {
            respuesta.data.contactos.forEach(contacto => {
              this.prospecto.contactos.push(<Contacto>{
                apellido: contacto.apellido,
                cargo: contacto.cargo,
                celularCodigoPais: contacto.celularCodigoPais,
                celularCodigoArea: contacto.celularCodigoArea,
                celularNumero: contacto.celularNumero,
                email: contacto.email,
                entidad: null,
                examen: contacto.examen,
                fechaAlta: contacto.fechaAlta,
                fechaCertificacion:contacto.fechaCertificacion,
                fechaModificacion:contacto.fechaModificacion,
                usuarioModificacion:null,
                dia_nacimiento:contacto.dia_nacimiento,
                mes_nacimiento:contacto.mes_nacimiento,
                fechaUltimaCertificacion:contacto.fechaCertificacion,
                idContacto:contacto.idContacto,
                interno:contacto.interno,
                kit:contacto.kit,
                nombre: contacto.nombre,
                pago: contacto.pago,
                perfil: contacto.perfil,
                razonSocial: contacto.razonSocial,
                telefonoCodigoPais: contacto.telefonoCodigoPais,
                telefonoCodigoArea: contacto.telefonoCodigoArea,
                telefonoNumero: contacto.telefonoNumero,
                tipoContacto: <TipoContacto>{
                  IdTipoContacto: contacto.tipo.id,
                  tipoContactoDesc: contacto.tipo.desc
                },
                fechaCreacion:contacto.fechaCreacion
              });
            });

            this.listadoContactos.setContactos(this.prospecto.contactos);
          }

          this.listadoContactos.setCargando(false);
        },
        () => {
          this.listadoContactos.setCargando(false);
        }
      );
    }
  }
}
